(function () {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('FileCountService', [
        '$rootScope',
        '$q',
        '$timeout',
        'FileService',
        'SessionManager',
        'SignalProvider',
        'AppConstants',
        FileCountService
    ]);

    function FileCountService ($rootScope, $q, $timeout, fileService, SessionManager, SignalProvider, AppConstants) {

        // AppConstant bindings
        var viewTypes = AppConstants.ViewTypes;

        var fileCountService = {
            counts: {
                COLLABORATE : {feedback: '', review: '', totals : ''}
            }
        };

        fileCountService.getCounts = function () {
            return fileCountService.counts;
        };

        fileCountService.updateCounts = function () {
            var completed = $q.defer();
            $timeout(function () {
                $q.all({
                    awaitingFeedback: fileService.getByTag(viewTypes.AWAITING_FEEDBACK_TYPE),
                    outForReview: fileService.getByTag(viewTypes.OUT_FOR_REVIEW_TYPE),
                }).then(function (serviceReturn) {
                    fileCountService.counts.COLLABORATE.feedback = (serviceReturn.awaitingFeedback.Documents.length > 0) ? serviceReturn.awaitingFeedback.Documents.length : '';
                    fileCountService.counts.COLLABORATE.review = (serviceReturn.outForReview.Documents.length > 0) ? serviceReturn.outForReview.Documents.length : '';
                    fileCountService.counts.COLLABORATE.totals = (fileCountService.counts.COLLABORATE.feedback +  fileCountService.counts.COLLABORATE.review);
                    completed.resolve(fileCountService.counts);
                });
            }, 0);
            return completed.promise;
        };

        fileCountService.signal = function () {
            $rootScope.$broadcast(SignalProvider.Sidebar.UpdateCounts);
        };

        fileCountService.emptyRecycleBin = function () {
            $rootScope.$broadcast(SignalProvider.Sidebar.EmptyRecycleBin);
        };

        return fileCountService;
    }
}());
